import { useEffect, useMemo, useState } from 'react'
import { DecodedEmailSettings } from 'src/api/types/currentCompany'
import {
  updateEmailNoticeFlag,
  updateEmailSettings,
  updateSmsNoticeFlag,
} from 'src/api/user'
import { LoginUser } from 'src/models/User'

export const useNoticeConfiguration = (user: LoginUser) => {
  // [key, label, onlyPaid]
  const categoryInfos = [
    ['is_receive_chat_email', '新着メッセージ通知', false],
    ['is_receive_request_email', 'つながり申請受信', false],
    ['is_receive_matching_email', '新規つながり', false],
    ['is_not_read_message_count_email', '未読メッセージのリマインド', false],
    ['is_request_count_email', 'つながり申請リマインド', false],
    // NOTE: 購買報告をヘッダーから削除に伴い、コメントアウト
    // ['is_purchase_notify_email', '購買報告リマインド ', false],
  ].filter(
    ([_key, _label, onlyPaid]) => !onlyPaid || user.company.paidPlan,
  ) as Array<[keyof DecodedEmailSettings, string, boolean]>

  const [isMounted, setIsMounted] = useState(false)
  const [settings, setSettings] = useState<DecodedEmailSettings | undefined>(
    undefined,
  )

  const [smsNoticeFlag, setSmsNoticeFlag] = useState(false)
  const [emailNoticeFlag, setEmailNoticeFlag] = useState(false)

  useEffect(() => {
    if (!isMounted && user.id !== 0) {
      setSettings(user.notice.receiveAllEmailSetting)
      setSmsNoticeFlag(user.notice.smsNoticeFlag)
      setEmailNoticeFlag(user.notice.emailNoticeFlag)

      setIsMounted(true)
    }
  }, [user.notice])

  const onChangeSettings = (key: string) => (value: boolean) => {
    if (!settings) return

    const nextSettings = { ...settings, [key]: value }
    setSettings(nextSettings)
    updateEmailSettings(user.id, nextSettings)
  }

  const isConnectedChatwork = useMemo(() => {
    return !!user.notice.chatworkApiToken
  }, [user])

  const isConnectedSlack = useMemo(() => {
    return !!user.notice.slackApiToken
  }, [user])

  const changeSmsNoticeFlag = (flag: boolean) => {
    updateSmsNoticeFlag(flag)
    setSmsNoticeFlag(flag)
  }

  const changeEmailNoticeFlag = (flag: boolean) => {
    updateEmailNoticeFlag(flag)
    setEmailNoticeFlag(flag)
  }

  return {
    isConnectedSlack,
    isConnectedChatwork,
    onChangeSettings,
    settings,
    smsNoticeFlag,
    emailNoticeFlag,
    changeSmsNoticeFlag,
    changeEmailNoticeFlag,
    categoryInfos,
  }
}
